import React, { useState } from 'react';
import JuiceCard from './JuiceCard';

const JuiceList = ({ juices, onAddToCart }) => {
  const [selectedCategory, setSelectedCategory] = useState('todos');

  const categories = ['todos', ...new Set(juices.map(juice => juice.category))];
  const filteredJuices = selectedCategory === 'todos' 
    ? juices 
    : juices.filter(juice => juice.category === selectedCategory);

  return (
    <div>
      <div className="flex space-x-2 mb-6 overflow-x-auto pb-2">
        {categories.map(category => (
          <button
            key={category}
            onClick={() => setSelectedCategory(category)}
            className={`px-4 py-2 rounded-full whitespace-nowrap ${
              selectedCategory === category
                ? 'bg-green-600 text-white'
                : 'bg-gray-100 text-gray-800 hover:bg-gray-200'
            } transition-colors`}
          >
            {category.charAt(0).toUpperCase() + category.slice(1)}
          </button>
        ))}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredJuices.map(juice => (
          <JuiceCard 
            key={juice.id} 
            juice={juice} 
            onSelect={onAddToCart} 
          />
        ))}
      </div>
    </div>
  );
};

export default JuiceList;